module.exports = __webpack_public_path__ + "img/colored_illustration.1cb3eaa9.png";